import getHash from '../../../Utilities/getHash';
// USAGE: obj.Distinct(); or obj.Distinct(['key1'],['key2']);
export default function distinct(enumerable, selector) {
    const temp = {};
    return enumerable.where(distinctPredicate(selector, temp));
}
function distinctPredicate(selector, temp) {
    return (item) => {
        const value = selector(item);
        let s_value;
        if (value instanceof Object) {
            s_value = getHash(value);
        }
        else {
            s_value = "" + value;
        }
        // if we aint storing it then it is unique, so store it
        if (!temp[s_value]) {
            // its unique
            temp[s_value] = true;
            return true;
        }
        // its a dupe
        return false;
    };
}
